import { useEffect, useState, useRef } from 'react';
import { useNavigation } from 'react-router-dom';
/**
 * ローディング制御用のカスタムフック
 *
 * このフックは、React Routerのナビゲーション状態を監視し、
 * ページ遷移中にローディング状態を管理します。
 *
 * 主な機能:
 * - ナビゲーションが開始されるとローディング状態をtrueに設定
 * - ナビゲーションが完了しても最低500msはローディングを表示
 * - skipLoadingフラグが設定されている場合はローディングを表示しない
 *
 * @returns {boolean} 現在のローディング状態
 */

export const useLoadingControl = () => {
  const navigation = useNavigation();
  const [isLoading, setIsLoading] = useState(false);
  const loadingStartTime = useRef<number | null>(null);
  const minLoadingTime = 500;

  useEffect(() => {
    if (navigation.state === 'loading') {
      if (!navigation.location?.state?.skipLoading) {
        loadingStartTime.current = performance.now();
        setIsLoading(true);
      }
    } else if (isLoading) {
      const elapsedTime = performance.now() - (loadingStartTime.current ?? 0);
      const delay = Math.max(minLoadingTime - elapsedTime, 0);

      const timer = setTimeout(() => {
        setIsLoading(false);
      }, delay);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [navigation.state, isLoading]);

  return isLoading;
};
